import { catalog } from "./catalog.js";
import { names } from "./names.js";

export const contracts = {
  catalog,
  names,
};
